import React, { useRef } from 'react';
import { CreditCard, Landmark, X } from 'lucide-react';

// Restyled to match the "panda" design system's modal shell
// (see panda-ui/components/ItemModal.js) instead of react-bootstrap's
// <Modal>. Only presentational - props/behavior are unchanged.
const UpdatePaymentModal = ({
  totalPrice,
  preset,
  show,
  onClose,
  currentModel,
  setCurrentModel,
}) => {
  const debounceTimer = useRef(null);
  const onHandlePress = type => {
    onClose();
    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }
    debounceTimer.current = setTimeout(() => {
      setCurrentModel(type);
    }, 1000);
  };

  if (!show) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-[#202124]/70 backdrop-blur-xs p-4"
      onClick={onClose}
    >
      <div
        className="relative bg-white rounded-2xl shadow-2xl max-w-md w-full border border-panda-tint p-6 sm:p-7"
        onClick={e => e.stopPropagation()}
      >
        <button
          type="button"
          onClick={onClose}
          aria-label="Close"
          className="absolute right-3 top-3 w-8 h-8 rounded-full bg-gray-100 text-gray-500 hover:bg-[#E53935] hover:text-white flex items-center justify-center transition-colors"
        >
          <X className="w-4 h-4" />
        </button>
        <h3 className="font-heading font-bold text-lg text-[#202124] pr-6">
          Choose your payment method
        </h3>
        <div className="mt-5 space-y-3">
          <button
            type="button"
            onClick={() => onHandlePress('card')}
            className="w-full flex items-center justify-center gap-2.5 py-3.5 px-4 rounded-xl bg-gradient-to-r from-panda-red to-panda-dark hover:from-panda-dark hover:to-panda-dark text-white font-heading font-bold text-sm shadow-md shadow-panda-red/30 active:scale-98 transition-all"
          >
            <CreditCard className="w-5 h-5" />
            Click to Update Credit Card
          </button>
          <div className="relative flex items-center py-1">
            <div className="flex-1 border-t border-gray-200" />
            <span className="px-3 text-[11px] font-bold text-gray-400 uppercase tracking-wider">
              Or
            </span>
            <div className="flex-1 border-t border-gray-200" />
          </div>
          <button
            type="button"
            onClick={() => onHandlePress('eft')}
            className="w-full flex items-center justify-center gap-2.5 py-3.5 px-4 rounded-xl border border-gray-200 hover:border-panda-red hover:text-panda-red text-[#202124] font-heading font-bold text-sm transition-colors"
          >
            <Landmark className="w-5 h-5" />
            Click to Update EFT
            <span className="text-[10px] font-bold text-[#65A30D] bg-green-50 px-1.5 py-0.5 rounded-md">
              Verified
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};
export default UpdatePaymentModal;
